import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const hrecsApi = {
    getHrecs: (): Observable<Dtos.GetHrecsResponse> => {
        //Create the request.
        let request: Dtos.GetHrecs = new Dtos.GetHrecs();

        //Send request.
        const response: Promise<Dtos.GetHrecsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getHrecById: (id: number): Observable<Dtos.GetHrecByIdResponse> => {
        //Create the request.
        let request: Dtos.GetHrecById = new Dtos.GetHrecById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetHrecByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setHrec: (hrec: Dtos.Hrec): Observable<Dtos.SetHrecResponse> => {

        let request: Dtos.SetHrec = new Dtos.SetHrec();

        request.hrec = hrec;

        // send request
        const response: Promise<Dtos.SetHrecResponse> = client.post(request);

        return Observable.from(response);

    },
    createHrec: (): Observable<Dtos.CreateHrecResponse> => {
        //Create the request.
        let request: Dtos.CreateHrec = new Dtos.CreateHrec();

        //Send request.
        const response: Promise<Dtos.CreateHrecResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateHrec: (hrec: Dtos.Hrec): Observable<Dtos.ValidateHrecResponse> => {

        let request: Dtos.ValidateHrec = new Dtos.ValidateHrec();

        request.hrec = hrec;

        // send request
        const response: Promise<Dtos.ValidateHrecResponse> = client.post(request);

        return Observable.from(response);

    }
}